import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { initSentry } from './utils/sentry';
import { initializeApp } from './utils/app-initialization';

import { routes } from './routes.ts';
import './index.css';

// Initialize Sentry before rendering
initSentry();

// Type for React Router hydration data
import type { RouterState } from 'react-router';

declare global {
  interface Window {
    __staticRouterHydrationData?: Partial<Pick<RouterState, 'loaderData' | 'actionData' | 'errors'>>;
  }
}

const router = createBrowserRouter(routes, {
	hydrationData: window.__staticRouterHydrationData,
});

// Initialize app with browser storage and services
initializeApp().then(() => {
  createRoot(document.getElementById('root')!).render(
    <RouterProvider router={router} />
  );
}).catch((error) => {
  console.error('Failed to initialize app:', error);
  // Still render the app but show an error state
  createRoot(document.getElementById('root')!).render(
    <div style={{ padding: '20px', color: 'red' }}>
      <h1>Initialization Error</h1>
      <p>Failed to initialize the application. Please refresh the page.</p>
      <details>
        <summary>Error Details</summary>
        <pre>{error.message}</pre>
      </details>
    </div>
  );
});
